<template>
  <div v-if="buttonRows.length" class="flex flex-col gap-3">
    <div
      v-for="(row, rowIndex) in buttonRows"
      :key="rowIndex"
      class="grid gap-[12px]"
      :class="{ 'grid-cols-2': row.length > 1 }"
    >
      <button
        v-for="(action, actionIndex) in row"
        :key="action.id || actionIndex"
        type="button"
        class="rounded-full inline-flex w-full border border-solid bg-transparent appearance-none py-2 px-4 items-center justify-center gap-x-2 cursor-pointer text-center font-bold text-[1rem] leading-[1.5rem] transition-opacity duration-200 active:scale-[0.98] active:opacity-80"
        :class="isLightMode ? 'border-[#21201E]' : 'border-[#ECEBEB]'"
        @click="onActionClick(action)"
      >
        <img
          v-if="resolveIcon(action)"
          :src="resolveIcon(action)"
          class="size-5"
          :class="{ 'invert-icon': !isLightMode }"
        />
        <span class="min-w-0 whitespace-normal break-words">{{ action.label }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const ACTION_ICON_MAP = {
  calendar: '/assets/icons/event-page/calendar-icon.svg',
  download: '/assets/icons/event-page/download-icon.svg',
  'external-link': '/assets/icons/event-page/external-link-icon.svg',
  file: '/assets/icons/event-page/file-text-icon.svg',
  info: '/assets/icons/event-page/info-icon.svg',
  link: '/assets/icons/event-page/link-icon.svg',
  map: '/assets/icons/event-page/map-pin-icon.svg',
  share: '/assets/icons/event-page/share-icon.svg',
  ticket: '/assets/icons/event-page/ticket-icon.svg',
  users: '/assets/icons/event-page/users-icon.svg',
};

export default {
  name: 'EventActionButtons',
  emits: ['action'],
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('eventPage', ['isLightMode']),
    buttonRows() {
      const rows = [];
      let row = [];

      for (const action of this.actions) {
        const full = action.width === 'full' || (action.label || '').length > 15;
        if (full) {
          if (row.length) {
            rows.push(row);
            row = [];
          }
          rows.push([action]);
        } else if (row.length) {
          row.push(action);
          rows.push(row);
          row = [];
        } else {
          row.push(action);
        }
      }

      if (row.length) rows.push(row);
      return rows;
    },
  },
  methods: {
    onActionClick(action) {
      console.log('[DEBUG EventActionButtons] button clicked, action:', JSON.stringify(action));
      this.$emit('action', action);
    },
    resolveIcon(action) {
      if (action.icon) return action.icon;
      if (action.iconKey && ACTION_ICON_MAP[action.iconKey]) {
        return ACTION_ICON_MAP[action.iconKey];
      }

      const fallbackByType = {
        download: ACTION_ICON_MAP.download,
        'download-media': ACTION_ICON_MAP.file,
        url: ACTION_ICON_MAP.link,
        share: ACTION_ICON_MAP.share,
      };

      return fallbackByType[action.buttonType] || '';
    },
  },
};
</script>

<style scoped>
.invert-icon {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(147deg) brightness(105%) contrast(101%);
}
</style>
